import {
  PageBlueprint,
  createFrontendPlugin,
  type FrontendFeature,
} from '@backstage/frontend-plugin-api';

const releasesPage = PageBlueprint.make({
  params: {
    path: '/releases',
    loader: () =>
      import('./ReleasesRouter').then(m => <m.ReleasesRouter />),
  },
});

export const releasesPlugin: FrontendFeature = createFrontendPlugin({
  pluginId: 'releases',
  extensions: [releasesPage],
});
